import React,{useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import { PortableText } from "@portabletext/react";
import { sanityClient } from "../../sanityClient";
import { sanityPortableTextComponents } from "../components/sanityPortableTextComponents";

const HeroBanner = styled("div")(({ theme }) => ({
  backgroundColor: "#FAE2CF",
  borderBottomLeftRadius: "24px",
  [theme.breakpoints.up(768)]: {
    borderBottomLeftRadius: "50px",
  },
}));

const CategoryTitle = styled("div")(({ theme }) => ({
  color: "#000 !important",
  fontSize: "32px !important",
  lineHeight: "1.2 !important",
  whiteSpace: "normal !important",
  fontFamily: "Helvetica Bold, sans-serif !important",
  fontWeight: "bold !important",
  margin: "0 0 1rem 0 !important",
  display: "block !important",
  textTransform: "none !important",
  [theme.breakpoints.up(768)]: {
    fontSize: "65px !important",
  },
  "&&&": {
    fontSize: "32px !important",
    [theme.breakpoints.up(768)]: {
      fontSize: "65px !important",
    },
  },
}));
const TermsAndConditionsText = ({ termsAndConditions }) => {
  return (
    <div className="container-lg">
        <div className="mb-3" >
            <h2>{termsAndConditions.title}</h2>
        </div>
      {termsAndConditions?.body && (
        <PortableText value={termsAndConditions.body} components={sanityPortableTextComponents} />
      )}
    </div>
  );
};




const TermsAndConditions = () => {
const[termsAndConditions, setTermsAndConditions] = useState(null);
    const getTermsAndConditions = async () => {
        const query = `*[_type == "termsAndConditions"] | order(sort asc) {
        _id,
        title,
        body
      }`;
    
        const termsAndConditions = await sanityClient.fetch(query);
        if(termsAndConditions?.length > 0){
            setTermsAndConditions(termsAndConditions?.[0]);
        }
        return termsAndConditions;
      };

      useEffect(() => {
        getTermsAndConditions();
      }, []);

    return (
        <>
            <section className="my-4 my-md-5 px-3">
                <HeroBanner className="container-lg px-0">
                    <div className="row g-0">
                        <div className="col-md-6 offset-md-1 px-3">
                            <div className="py-4 py-md-5">
                                <CategoryTitle className="mb-3">
                                Terms And Conditions
                                </CategoryTitle>
                                <p>
                                    Read our terms and conditions to understand your rights and responsibilities when using Mockee.
                                    <br />
                                </p>
                            </div>
                        </div>
                        <div className="col-md-5 px-0">
                            <div className="h-100 d-flex justify-content-end" style={{ paddingRight: "30px" }}>
                                <img
                                    src="/assets/images/ToS.svg"
                                    alt="Terms And Conditions"
                                    className="img-fluid h-100 mb-hidden object-fit-cover"
                                    style={{
                                        borderTopLeftRadius: "60px",
                                        width: "45%",
                                        objectFit: "contain",
                                        objectPosition: "right center",
                                        transform: "scaleX(-1)",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </HeroBanner>
            </section>
            <section className="terms-use py-4 py-md-5">
        {termsAndConditions && (
            <TermsAndConditionsText termsAndConditions={termsAndConditions} />
        )}
            </section>
        </>
    );
};

export default TermsAndConditions;